export default {
  getKpis(state) {
    return state.dashboard?.kpis;
  },
  getDashboard(state) {
    return state.dashboard;
  },
};
